export default function getResource(label) {
    const resources = {
        modalTitle: 'Ajouter l’adresse',
        setAsDefault: 'Définir comme l’adresse de livraison par défaut',
        enterAddressManually: 'Entrer l’adresse manuellement',
        cancel: 'Annuler',
        confirm: 'Utiliser cette adresse'
    };

    return resources[label];
}
